import { render, staticRenderFns } from "./VirtualAssistantConsumptionsReports.vue?vue&type=template&id=32d2ea6a&scoped=true&"
import script from "./VirtualAssistantConsumptionsReports.vue?vue&type=script&lang=js&"
export * from "./VirtualAssistantConsumptionsReports.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAssistantConsumptionsReports.vue?vue&type=style&index=0&id=32d2ea6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2ea6a",
  null
  
)

export default component.exports